module.exports = __webpack_public_path__ + "static/hero-loans-b35c7da921a955ef74b8455ee7630d87.webp";